import React from "react";
import { ChevronRight } from "lucide-react";

interface IThingsToKnowTileProps {
  /** The app's tile icon (public/icons/listing). */
  iconSrc: string;
  title: string;
  /** The detail lines under the title. */
  children: React.ReactNode;
  onOpen: () => void;
}

/**
 * A "Things to know" tile (`listing_things_to_know.dart`): icon and title, the detail
 * lines indented under them, and a chevron on the right; the whole tile opens its sheet.
 */
const ThingsToKnowTile: React.FC<IThingsToKnowTileProps> = ({
  iconSrc,
  title,
  children,
  onOpen,
}) => (
  <button
    type="button"
    onClick={onOpen}
    aria-haspopup="dialog"
    className="group flex w-full items-center gap-3 text-left"
  >
    <span className="flex min-w-0 flex-1 flex-col">
      <span className="flex items-center gap-2">
        <span className="flex w-[41px] shrink-0 justify-center">
          <img src={iconSrc} alt="" className="h-6 w-auto" />
        </span>
        <span className="text-base font-medium text-ink group-hover:underline">
          {title}
        </span>
      </span>
      <span className="mt-1.5 block pl-11 text-base text-ink-secondary">
        {children}
      </span>
    </span>
    <ChevronRight aria-hidden className="h-[18px] w-[18px] shrink-0 text-ink" />
  </button>
);

export default ThingsToKnowTile;
